import Head from "next/head";
import Header from "@/components/shared/Header";
// import Login from "@/components/dashboard/Login";
import MagicLink from "@/components/dashboard/MagicLink";
import { routes } from "@/constants/routes/routes";
import { useEffect } from "react";
import { useAuth } from "@/shared/hooks/useAuth";
import { useRouter } from "next/router";

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isAuthenticated) {
      router.replace(routes.dashboard.root);
    }
  }, [isAuthenticated, router]);

  return (
    <>
      <Head>
        <title>Log In to your Keyzy Application</title>
        <link rel="canonical" href="https://www.keyzy.com/dashboard/login" />
        <meta
          name="description" key="description"
          content="Log in to your application with Keyzy to rent-to-buy your future home. Our easy-to-use platform makes it simple to get started."
        />
        <meta
          name="twitter:card"
          content="Log in to your application with Keyzy to rent-to-buy your future home. Our easy-to-use platform makes it simple to get started."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta property="og:image" content="/landing/keyzy-meta-image.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta property="og:title" content="Log In to your Keyzy Application" key="ogtitle" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Log in to your application with Keyzy to rent-to-buy your future home. Our easy-to-use platform makes it simple to get started."
          key="ogdesc"
        />
      </Head>

      <Header noAccount text="LOG IN" isLoginLayout />

      <div className="min-h-full pb-20 bg-gradient-grey-dark">
        <div className="md:w-[645px] mx-auto pt-8 md:pt-28">
          {/*
          Replace <Login /> with <MagicLink /> to switch from the old login form to the new magic link flow. Remember to also update the import statements at the top of this file.
          <LoginPage /> */}
          <MagicLink />
        </div>
      </div>
    </>
  );
};

export default LoginPage;
